import DemandStudioSkeleton from '../demand-studio/DemandStudioSkeleton';
import CertifiedPlannerOptionCard from './CertifiedPlannerOptionCard';
import CertifiedSupportOptionCard from './CertifiedSupportOptionCard';
import {
    fullscreenClasses,
    bodyClasses,
    bodyInnerClasses,
    pairGridClasses,
} from './preliminaryLifecareClasses';

const closeFloatingClasses =
    'absolute top-4 right-6 z-10 flex items-center justify-center h-10 w-10 rounded-full ' +
    'bg-surface text-content border border-border shadow-sm cursor-pointer hover:text-primary';

const PreliminaryLifecarePlanRequestLayout = ({ state }) => {
    const {
        planner,
        isLoadingPlanner,
        costLabel,
        isSubmitting,
        confirmRequest,
        isRequestingSupport,
        requestSupport,
        handleClose,
    } = state;

    return (
        <div className={`${fullscreenClasses} relative`}>
            <button type="button" className={closeFloatingClasses} onClick={handleClose} aria-label="Close">
                <i className="fa fa-times" />
            </button>

            <div className={bodyClasses}>
                {isLoadingPlanner ? (
                    <DemandStudioSkeleton />
                ) : (
                    <div className={`${bodyInnerClasses} min-h-full justify-center`}>
                        <div className={`${pairGridClasses} max-w-4xl mx-auto w-full`}>
                            <CertifiedPlannerOptionCard
                                planner={planner}
                                costLabel={costLabel}
                                isSubmitting={isSubmitting}
                                onConfirm={confirmRequest}
                            />
                            <CertifiedSupportOptionCard
                                isRequesting={isRequestingSupport}
                                onRequestSupport={requestSupport}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PreliminaryLifecarePlanRequestLayout;
